module.exports = __webpack_public_path__ + "assets/basic-close-23a0bb.svg";